var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDl(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 60,
    viewBox: "0 0 74 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.2738 53.61L37 36.855V0L71.2738 53.61ZM74 60L37 44.145V60H74Z",
    fill: "#98002E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72632 53.61L37.0001 0V36.855L2.72632 53.61Z",
    fill: "#E31837"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.9995H37V44.1445L0 59.9995Z",
    fill: "#E31837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDl);
export default __webpack_public_path__ + "static/media/DL.31f2ac024da2e03a3340cc23f839f55c.svg";
export { ForwardRef as ReactComponent };